import React from 'react';
import { useQuery } from '@apollo/client';
import Tooltip from '@atlaskit/tooltip';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { fetchBillingProfileNameById } from './queries/fetch-billing-profile-name-by-id';
import { NoData } from './no-data';

export const BillingProfileNumberFromId: React.FC<{ id?: string | null; txaId: string; loaderWidth?: string }> = ({
  id,
  txaId,
  loaderWidth = '100%',
}) => {
  const { data, loading, error } = useQuery<
    generatedTypesNew.FetchBillingProfileNameByIdQuery,
    generatedTypesNew.FetchBillingProfileNameByIdQueryVariables
  >(fetchBillingProfileNameById, {
    variables: {
      id: id ?? '',
      txaId,
    },
    displayName: 'fetchBillingProfileNameById',
    fetchPolicy: 'cache-and-network',
    skip: !id,
  });

  if (error) {
    return <NoData />;
  }

  if (loading) {
    return (
      <SkeletonLoaderWrapper>
        <SkeletonLoader marginBottom="0" width={loaderWidth} />
      </SkeletonLoaderWrapper>
    );
  }

  const billingProfileNumber = data?.invoiceGroup?.invoiceGroupNumber || id;

  return id ? (
    <Tooltip content={billingProfileNumber} tag="span">
      {billingProfileNumber}
    </Tooltip>
  ) : (
    <NoData />
  );
};
